import { render, staticRenderFns } from "./TransferStepsWidget.vue?vue&type=template&id=389b7a68&scoped=true"
import script from "./TransferStepsWidget.vue?vue&type=script&lang=ts"
export * from "./TransferStepsWidget.vue?vue&type=script&lang=ts"
import style0 from "./TransferStepsWidget.vue?vue&type=style&index=0&id=389b7a68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389b7a68",
  null
  
)

export default component.exports